{
  "version": "1.2.6",
  "objects": {
    "7433058470924502446": {
      "type": "frame",
      "id": "7433058470924502446",
      "z": 2106,
      "textContent": "",
      "left": -559.1709684019825,
      "top": 116.64252515039766,
      "width": 400,
      "height": 500,
      "scaleX": 1.1448881298101639,
      "scaleY": 0.8252444708109697,
      "fill": "#FFFFFF",
      "opacity": 1,
      "notInNavigation": false,
      "componentName": "",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7433058470928183179": {
      "type": "frame",
      "id": "7433058470928183179",
      "z": 1426,
      "textContent": "Frame 20",
      "left": -539.1709684019825,
      "top": 469.2647605558825,
      "width": 400,
      "height": 500,
      "scaleX": 1.0448881298101638,
      "scaleY": 0.08,
      "fill": "transparent",
      "opacity": 1,
      "container": "7433058470924502446",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a3",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": 10,
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7433058470924509595": {
      "type": "wireframe",
      "id": "7433058470924509595",
      "z": 1476,
      "top": 469.7647605558825,
      "left": -539.1709684019825,
      "width": 144.1787109375,
      "height": 40,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7433058470928183179",
      "layoutPosition": "a1",
      "wireframeName": "button",
      "fill": "#CD7C35",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": {
        "state": "default",
        "value": "Read blog post",
        "iconLeft": { "prefix": "fas", "iconName": "book-open-reader" },
        "iconRight": null
      }
    },
    "7433058470946230969": {
      "type": "frame",
      "id": "7433058470946230969",
      "z": 1446,
      "textContent": "Frame 25",
      "left": -539.1709684019825,
      "top": 330.3343369911103,
      "width": 400,
      "height": 500,
      "scaleX": 1.0448881298101638,
      "scaleY": 0.23786084712954436,
      "fill": "transparent",
      "opacity": 1,
      "container": "7433058470924502446",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "user",
      "layoutGap": 10,
      "layoutPadding": 10,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7433058470946825859": {
      "type": "shape",
      "id": "7433058470946825859",
      "z": 1496,
      "shapeName": "text",
      "textContent": "<p>Paragraph text</p>",
      "left": -529.1709684019825,
      "top": 406.3343369911103,
      "width": 230.96371954889239,
      "height": 30.17616436317187,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8616071839710477,
      "scaleY": 0.8616071839710477,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12.062500575594669,
      "angle": 0,
      "container": "7433058470946230969",
      "authorId": "7403380887301200427",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    },
    "7433058470951355495": {
      "type": "shape",
      "id": "7433058470951355495",
      "z": 1486,
      "shapeName": "text",
      "textContent": "<p><span style=\"color:#7D3C00\">Title</span></p>",
      "left": -529.1709684019825,
      "top": 340.3343369911103,
      "width": 35.773429338068794,
      "height": 29.460471219586065,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.900852148039295,
      "scaleY": 1.900852148039295,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 26.61193007255013,
      "angle": 0,
      "container": "7433058470946230969",
      "authorId": "7403380887301200427",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "locked": false
    },
    "7433058470950443117": {
      "type": "frame",
      "id": "7433058470950443117",
      "z": 1436,
      "textContent": "Frame 2",
      "left": -539.1709684019825,
      "top": 136.64252515039766,
      "width": 400,
      "height": 500,
      "scaleX": 1.0448881298101638,
      "scaleY": 0.34738362368142534,
      "fill": "#E37103",
      "opacity": 0.05,
      "container": "7433058470924502446",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "parent",
      "layoutGap": 0,
      "layoutPadding": 0,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "top"
    }
  }
}
